<div class="main-content">
  <div class="main-heading">
    <span translate
      >{{ isEditMode ? ("EDIT" | translate) : ("NEW" | translate) }}
      {{ "CONTRACT_EL" | translate }}
    </span>
  </div>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="elForm">
        <div class="row">
          <div class="col-sm-6">
            <span
              class="radio-inline"
              *ngFor="let option of options"
              style="margin-right: 10px"
            >
              <label>
                <input
                  type="radio"
                  formControlName="Status"
                  [checked]="option.id === elForm.controls['Status'].value"
                  name="Status"
                  [value]="option.id"
                />{{ option.name | translate }}
              </label>
            </span>

            <div class="form-group pt-2">
              <label for="Title">
                <span translate>CONTRACT_NUMBER</span>
                <span class="required">*</span>
              </label>
              <div>
                <input
                  pInputText
                  (keypress)="onContractNumber($event, 35)"
                  formControlName="ContractNumber"
                  id="ContractNumber"
                  class="ex-full-width"
                />
              </div>
            </div>
            <div class="form-group">
              <label>
                <span translate>CONTRACT_NAME</span>
                <span class="required">*</span>
              </label>
              <div>
                <input
                  type="text"
                  pInputText
                  formControlName="ContractName"
                  id="ContactName"
                  class="ex-full-width"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="Comments">
                <span translate>COMMENTS</span>
              </label>
              <div>
                <textarea
                  pTextarea
                  id="Comments"
                  formControlName="Comments"
                  class="ex-description"
                ></textarea>
              </div>
            </div>
            <div class="form-group">
              <label for="EmailDevaition">
                <span translate>EMAIL_NEWDEVIATION_LABEL</span>
              </label>
              <div *ngIf="bindSelectedUsers">
                <p-multiSelect
                  placeholder="{{ 'SELECT' | translate }}"
                  [dataKey]="'Id'"
                  [options]="userSubscribers"
                  formControlName="selectedEmailSubscriber"
                  [style]="{ width: '100%' }"
                >
                  <ng-template
                    let-emailDeviation
                    let-i="index"
                    pTemplate="item"
                  >
                    {{ i }}
                    <span>{{ emailDeviation.label }}</span>
                  </ng-template>
                </p-multiSelect>
              </div>
              <div *ngIf="bindAllUsers">
                <p-multiSelect
                  placeholder="{{ 'SELECT' | translate }}"
                  [dataKey]="'Id'"
                  [options]="selectedSubscribers"
                  formControlName="selectedEmailSMSSubscriber"
                  [style]="{ width: '100%' }"
                >
                  <ng-template
                    let-emailDeviations
                    let-i="index"
                    pTemplate="item"
                  >
                    {{ i }}
                    <span>{{ emailDeviations.label }}</span>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
            <div class="checkbox">
              <label class="kuba-choice-label"><p-checkbox
                formControlName="IsShowDeviationChecked"
                binary="true"
              ></p-checkbox><span>{{ 'DO_NOT_DISPLAY_DEVIATION' | translate }}</span></label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group" [hidden]="isEditMode">
              <div class="sub-panel-title">
                <span translate>COPYFOLDERS_CONTENT</span>
              </div>
              <label for="ChooseContract" translate>CHOOSE_CONTRACT</label>
              <div>
                <p-select
                  [options]="elList"
                  id="ChooseContract"
                  formControlName="ChooseContracts"
                  [style]="{ width: '500px' }"
                ></p-select>
              </div>
              <label class="kuba-choice-label"><p-checkbox
                value="CopySja"
                formControlName="CopySJA"
                binary="true"
              ></p-checkbox><span>{{ 'COPY_SJA' | translate }}</span></label>
            </div>

            <div class="upload-file-container">
              <label for="Avatar">
                <span translate>CONTRACT_IMAGE</span>
              </label>
              <div class="form-group">
                <div class="upload-file-container">
                  <div class="upload-actions">
                    <input
                      type="file"
                      id="businessfiles"
                      class="hidden"
                      (change)="filesSelect($event)"
                    />
                    <label
                      for="businessfiles"
                      class="btn btn-outline-primary"
                      translate
                      >UPLOAD_IMAGE</label
                    >
                  </div>
                  <div *ngIf="uploadStart">
                    <span translate>IMAGE_IS_UPLOADING</span>
                  </div>
                  <div *ngIf="kundeElImage != null">
                    <img src="{{ kundeElImage }}" alt="" width="200px" />
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-panel-title">
              <span translate>ASSIGN_CONTRACT</span>
            </div>
            <div class="table-view">
              <!-- Table starts -->
              <p-table
                #dt
                [value]="elUsers"
                dataKey="Id"
                scrollable="true"
                scrollHeight="200px"
              >
                <!-- Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                      <p-checkbox
                        [ngModel]="checkedAll"
                        (ngModelChange)="checkAll($event)"
                        [ngModelOptions]="{ standalone: true }"
                        binary="true"
                      ></p-checkbox>
                    </th>
                    <th>{{ "NAME" | translate }}</th>
                  </tr>
                </ng-template>
                <!-- Body Content -->
                <ng-template pTemplate="body" let-kundeEL>
                  <tr>
                    <td>
                      <p-checkbox
                        [ngModel]="kundeEL.Id === userId || kundeEL.status"
                        [disabled]="kundeEL.Id === userId"
                        (ngModelChange)="kundeEL.status = $event; checked(kundeEL)"
                        [ngModelOptions]="{ standalone: true }"
                        binary="true"
                      ></p-checkbox>
                    </td>
                    <td>
                      <span>{{ kundeEL.Name }}</span>
                    </td>
                  </tr>
                </ng-template>
                <!-- Empty message -->
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td colspan="2">
                      {{ "NO_RECORDS_FOUND" | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <!-- Table Ends-->
            </div>
            <div class="pt-2 sm-12">
              <h6 translate>CLIENT_KUNDE</h6>
              <div class="input-btn-group">
                <p-select
                  [options]="clients"
                  #clientDropdown
                  (onChange)="onClientChanged($event)"
                  formControlName="ClientId"
                  [style]="{ width: '100%' }"
                  placeholder="{{ 'SELECT_DROPDOWN' | translate }}"
                  [showClear]="true"
                >
                </p-select>

                <a
                  *ngIf="!editClient"
                  class="btn btn-outline-primary"
                  [routerLink]="['./../../client/new']"
                  routerLinkActive="active"
                >
                  <i class="pi pi-plus" aria-hidden="true"></i>
                </a>
                <a
                  *ngIf="editClient"
                  class="btn btn-outline-primary"
                  [routerLink]="['./../../../client/new']"
                  routerLinkActive="active"
                >
                  <i class="pi pi-plus" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            <div *ngIf="showAssignClient" class="pt-2 sm-12">
              <h6 translate>ASSIGN_CLIENT</h6>

              <p-table
                #client
                [value]="kundeElClientUsers"
                dataKey="Id"
                [(selection)]="selectedClient"
                scrollable="true"
                scrollHeight="300px"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 38px">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>{{ "NAME" | translate }}</th>
                  </tr>
                  <tr>
                    <th style="width: 38px"></th>
                    <th>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          client.filter(
                            $any($event.target)?.value,
                            'Name',
                            'contains'
                          )
                        "
                        placeholder=""
                        class="p-column-filter"
                        style="width: 100%"
                      />
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-project>
                  <tr>
                    <td style="width: 38px">
                      <p-tableCheckbox id="selectedOrders" [value]="project">
                      </p-tableCheckbox>
                    </td>
                    <td>
                      <span>{{ project.Name }}</span>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td colspan="2">
                      {{ "NO_RECORDS_FOUND" | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="action-btns-wrapper">
          <button class="btn btn-outline-secondary" (click)="gotoBack()">
            <i class="pi pi-arrow-left"></i>
            <span translate>BACK_LIST</span>
          </button>
          <button
            *ngIf="isGuestButtonHide"
            class="btn btn-primary"
            (click)="saveChanges()"
            [disabled]="!elForm.valid"
          >
            <span translate>SAVE_AND_BACK</span>
          </button>
          <button
            *ngIf="isGuestButtonHide"
            class="btn btn-primary"
            type="submit"
            (click)="saveAndCreateNew()"
            [disabled]="!elForm.valid"
          >
            <span translate>SAVE_CREATE_NEW</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
